const doc = [({"en":({"indexTitle":"LP contents list", "newTitle":"Create LP contents", "editTitle":"Edit LP contents"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;